import { z } from 'zod';
import { viewName } from './_shared';

export const app_opened = z.object({ from_install: z.boolean() }).strict();

export const view_switched = z.object({ from: viewName, to: viewName }).strict();

export const pwa_installed = z.object({}).strict();
